export enum DoorSteelStiffen {
  NONE = 'None',
  _16 = '16 Gauge',
  _18 = '18 Gauge',
  _20 = '20 Gauge',
}
